import { Component, Input, OnChanges } from '@angular/core';
import { KPI } from '../../../@core/api';
import { InitiativesService, ScopeService } from '../../../@core/utils';
import { Observable, map, combineLatest } from 'rxjs';
import { NbCardModule } from '@nebular/theme';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { idMapToArray } from '../../../@core/utils/scope.service';
import { ThousandsSeparatorPipe } from '../../pipes';

export interface DisplayedInitiativeGain {
  id: number;
  kwhSavings: number;
  energyTypeName: string;
  co2Savings: number;
  refrigerantTypeName: string;
  precision: KPI.GainPrecision;
  origin: KPI.GainOrigin;
}

@Component({
  selector: 'app-initiative-gains-list',
  standalone: true,
  imports: [
    NbCardModule, AsyncPipe, TranslateModule, ThousandsSeparatorPipe
  ],
  templateUrl: './initiative-gains-list.component.html',
  styleUrl: './initiative-gains-list.component.scss'
})
export class InitiativeGainsListComponent implements OnChanges {

  
  @Input({required: true}) public gainType: KPI.GainType;
  @Input({required: true}) public initiativeGains: KPI.InitiativeGain[];

  public gains$: Observable<DisplayedInitiativeGain[]>;

  constructor(
    private readonly initiativesService: InitiativesService,
    private readonly scopeService: ScopeService,
  ) {}

  public ngOnChanges(): void {
    this.gains$ = combineLatest([
      this.initiativesService.initiativeEnergyTypes$,
      this.scopeService.refrigerantTypes$.pipe(idMapToArray()),
    ]).pipe(
      map(([energyTypes, refrigerantTypes]) => this.initiativeGains.map((initiativeGain) => ({
        id: initiativeGain.id,
        // KWH Savings
        kwhSavings: initiativeGain.theoretical_savings_full_year,
        energyTypeName: energyTypes.find((energyType) => energyType.id === initiativeGain.energy_type_id)?.name || '',
        // CO2 Savings 
        co2Savings: initiativeGain.theoretical_greenhouse_gas_savings_full_year,
        refrigerantTypeName: refrigerantTypes.find((refrigerantType) => refrigerantType.id === initiativeGain.refrigerant_type_id)?.name || '',
        origin: initiativeGain.gain_origin,
        precision: initiativeGain.gain_precision,
      }))),
    );
  }

}
